export const AddNewIcon: React.VFC<React.SVGAttributes<SVGElement>> = ({
  ...nativeProps
}) => {
  return (
    <svg
      {...nativeProps}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 203"
    >
      <rect fill="#f9f9f9" width="200" height="203" />
      <path
        fill="#161015"
        d="M80,101.5c0-11,9-20,20-20s20,9,20,20s-9,20-20,20S80,112.5,80,101.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M100,92.2c0.6,0,1.2,0.5,1.2,1.2v16.3c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2V93.3
	C98.8,92.7,99.4,92.2,100,92.2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M90.7,101.5c0-0.6,0.5-1.2,1.2-1.2h16.3c0.6,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2H91.8
	C91.2,102.7,90.7,102.1,90.7,101.5z"
      />
    </svg>
  )
}
